import { SoftwareServices, WhyPeopleChooseUs } from "../../components";
import InfoSectionWelcome from "./InfoSectionWelcome/InfoSectionWelcome";
import Contact from "../../components/contact/Contact";
import { Footer } from "../../components";

function Home() {
  return (
    <div id="home">
      <InfoSectionWelcome />
      <SoftwareServices />
      <WhyPeopleChooseUs />
      {/* <InfoSection {...homeObjFour} /> */}
      <Contact />
      <Footer />
    </div>
  );
}

export default Home;
